import React from 'react';
import { MessageSquare, ShieldCheck } from 'lucide-react';

const WelcomeMessage = () => {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center bg-gray-50 dark:bg-[#191c22] p-8 text-center font-['Poppins']">
      <div className="max-w-md flex flex-col items-center">
        <div className="w-24 h-24 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mb-8 animate-pulse">
          <MessageSquare size={48} className="text-blue-600 dark:text-blue-400" />
        </div>
        
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-white mb-4">
          Hellocer Messaging
        </h1>
        
        <p className="text-gray-600 dark:text-gray-400 text-[13px] mb-12 leading-relaxed">
          Select a conversation from the sidebar to start messaging. 
          Connect with world-class talents and coordinate your projects seamlessly.
        </p>
        
      </div>
      
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 p-20 opacity-5 pointer-events-none">
          <MessageSquare size={120} />
      </div>
      <div className="absolute bottom-0 left-0 p-20 opacity-5 pointer-events-none">
          <MessageSquare size={80} />
      </div>
    </div>
  );
};

export default WelcomeMessage;
